import { Map } from "immutable";

export const initialState = Map({});

export default (state = initialState, action) => state;
